import { 
    GET_PLAYERS,
    CLEAR_PLAYERS,
    GET_PLAYERS_SUCCESS,
    SET_QUIZ_FILTER_PLAYER,
    SET_QUIZ_FILTER_PLAYER_SUCCESS,
    DELETE_QUIZ_USER_PLAYER,
    DELETE_QUIZ_USER_PLAYER_SECCESS,
    PSEUDONONYMIZE_PLAYER,
    PSEUDONONYMIZE_PLAYER_SECCESS,
    DOWNLOAD_QUIZ_PLAYERS_EXPORT_FILE,
    DOWNLOAD_QUIZ_PLAYERS_EXPORT_FILE_SUCCESS,
    DELETE_QUIZ_ALL_USER_PLAYERS,
    DELETE_QUIZ_ALL_USER_PLAYERS_SUCCESS
} from './constants';

/**
 *
 * @param id
 * @param from
 * @param to
 * @param resolve
 * @returns {{resolve: *, from: *, id: *, to: *, type: string}}
 */
const getPlayers = (id, from, to, resolve) => ({
    type: GET_PLAYERS,
    id,
    from,
    to,
    resolve
});
/**
 *
 * @returns {{type: string}}
 */
const clearPlayers = () => ({
    type: CLEAR_PLAYERS,
});

/**
 *
 * @param players
 * @returns {{players: *, type: string}}
 */
const getPlayersSuccess = players => ({
    type: GET_PLAYERS_SUCCESS,
    players
});
/**
 *
 * @param quizID
 * @param from
 * @param to
 * @param hatchId
 * @returns {{hatchId: *, quizID: *, from: *, to: *, type: string}}
 */
const setQuizFilter = (quizID, from, to, hatchId) => ({
    type: SET_QUIZ_FILTER_PLAYER,
    quizID,
    from,
    to,
    hatchId
});
/**
 *
 * @param players
 * @returns {{players: *, type: string}}
 */
const setQuizFilterSuccess = players => ({
    type: SET_QUIZ_FILTER_PLAYER_SUCCESS,
    players
});
/**
 *
 * @param id
 * @param quizID
 * @returns {{quizID: *, id: *, type: string}}
 */
const deleteQuizUserPlayer = (id, quizID)=> ({
    type: DELETE_QUIZ_USER_PLAYER, 
    id,
    quizID
});

const pseudononymizePlayer = (id, quizID)=> ({
    type: PSEUDONONYMIZE_PLAYER, 
    id,
    quizID
});
/**
 *
 * @param players
 * @returns {{players: *, type: string}}
 */
const deleteQuizUserPlayerSuccess = players => ({
    type: DELETE_QUIZ_USER_PLAYER_SECCESS,
    players
});

const pseudononymizePlayerSuccess = players => ({
    type: PSEUDONONYMIZE_PLAYER_SECCESS,
    players
});
/**
 *
 * @param quizID
 * @returns {{quizID: *, type: string}}
 */
const downloadQuizPlayersExportFile = quizID => ({
    type: DOWNLOAD_QUIZ_PLAYERS_EXPORT_FILE,
    quizID
});
/**
 *
 * @param file
 * @returns {{file: *, type: string}}
 */
const downloadQuizPlayersExportFileSuccess = file => ({
    type: DOWNLOAD_QUIZ_PLAYERS_EXPORT_FILE_SUCCESS,
    file
});
/**
 *
 * @param quizID
 * @param typeData
 * @param withPlayers
 * @returns {{withPlayers: *, quizID: *, type: string, typeData: *}}
 */
const deleteQuizAllUserPlayers = (quizID, typeData, withPlayers) => ({
    type: DELETE_QUIZ_ALL_USER_PLAYERS,
    quizID,
    typeData,
    withPlayers
});
/**
 *
 * @param players
 * @returns {{players: *, type: string}}
 */
const deleteQuizAllUserPlayersSuccess = players => ({
    type: DELETE_QUIZ_ALL_USER_PLAYERS_SUCCESS,
    players
});

export {
    getPlayers,
    clearPlayers,
    getPlayersSuccess,
    setQuizFilter,
    setQuizFilterSuccess,
    deleteQuizUserPlayer,
    deleteQuizUserPlayerSuccess,
    pseudononymizePlayer,
    pseudononymizePlayerSuccess,
    downloadQuizPlayersExportFile,
    downloadQuizPlayersExportFileSuccess,
    deleteQuizAllUserPlayers,
    deleteQuizAllUserPlayersSuccess
};